import {
  retrieveDismissedMessages,
  storeDismissedMessage,
} from 'js/alert-banners';

/**
 * Action types.
 */
export const RECEIVE_DISMISSED_MESSAGES = 'receive_dismissed_messages';
export const CHANGE_BANNER_INDEX = 'change_banner_index';

/**
 * Initial module state.
 */
const initialState = {
  activeBanners: {},
  dismissedMessages: retrieveDismissedMessages(new Date()),
};

/**
 * Reducer function. Accepts a state and an action, and returns the modified
 * state depending on the action type. If no matching action types are found,
 * returns the unmodified state.
 *
 * @param {object} state - The state to modify or return.
 * @param {object} action - The action type to analyze.
 * @returns {object} - The new state value.
 */
export default function reducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CHANGE_BANNER_INDEX:
      return {
        ...state,
        activeBanners: {
          ...state.activeBanners,
          [payload.bannerType]: {
            position: payload.newIndex + 1,
            url: payload.newUrl,
          },
        },
      };

    case RECEIVE_DISMISSED_MESSAGES:
      return {
        ...state,
        dismissedMessages: payload,
      };

    default:
      return state;
  }
}

/**
 * Fires when changing the message displayed in a banner.
 *
 * @param {string} bannerType Banner type.
 * @param {string} newIndex The index within the set of messages to display.
 * @param {string} newUrl The new URL to link the banner to.
 * @return {{payload: {bannerType: *, newUrl: *, newIndex: *}, type: string}}
 */
export function changeBannerMessage(bannerType, newIndex, newUrl) {
  return {
    type: CHANGE_BANNER_INDEX,
    payload: {
      bannerType,
      newIndex,
      newUrl,
    },
  };
}

/**
 * Fires when receiving updated dismissed message UUIDs for the page.
 *
 * @param messages
 * @return {{payload: *, type: string}}
 */
export function receiveDismissedMessages(messages) {
  return {
    type: RECEIVE_DISMISSED_MESSAGES,
    payload: messages,
  };
}

/**
 * Thunk for adding a dismissed banner UUID to local storage, then notifying the store.
 *
 * @param {String} uuid Dismissed UUID.
 * @param {Integer} dismissFor Length of time to dismiss message for, in milliseconds.
 * @param {String} storage Storage layer to use.
 */
export function dismissMessage(uuid, dismissFor, storage) {
  return (dispatch) => {
    const now = new Date();

    storeDismissedMessage(uuid, now, dismissFor, storage);
    dispatch(receiveDismissedMessages(retrieveDismissedMessages(now)));
  };
}
